import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-landing-page-footer',
  templateUrl: './landing-page-footer.component.html',
  styleUrls: ['./landing-page-footer.component.scss']
})
export class LandingPageFooterComponent implements OnInit {

  currentYear: number = new Date().getFullYear(); 

  constructor() { }

  ngOnInit(): void {
  }
  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
